import locale from './menuLanguage';
export default {
    menu: [{
        'mainTitle': locale.logisticsMenu.logisCurrentPosition,
        'link': '/logisticsProvider.html#/',
        'type': 'Group', // 没有子菜单
        'alias': 'personalCenter',
        'id': 17
    }],
    logisticsProvider: [{
            'mainTitle': locale.logisticsMenu.logisCurrentPosition, // 当前位置
            'link': '/logisticsProvider.html#/',
            'type': 'Group', // 没有子菜单
            'alias': 'personalCenter',
            'id': 17
        },
        {
            'mainTitle': locale.logisticsMenu.OverseasWarehouse, // 物流商
            'type': 'Group-title',
            'icon': 'icon-shenhe',
            'id': 18,
            'pid': 17
        },
        {
            'mainTitle': locale.logisticsMenu.personalCenter, // 个人中心
            'id': 19,
            'icon': '',
            'pid': 18,
            'link': '/logisticsProvider.html#/personalCenter',
            'menuKey': 'personalCenter'
        },
        {
            'mainTitle': locale.logisticsMenu.warehouseManagement, // 仓库
            'id': 20,
            'icon': '',
            'pid': 18,
            'link': '/logisticsProvider.html#/warehouse',
            'menuKey': 'warehouse'
        },
        {
            'mainTitle': locale.logisticsMenu.channelManagement,// 渠道管理
            'id': 21,
            'icon': '',
            'pid': 18,
            'link': '/logisticsProvider.html#/owchannelManagement',
            'menuKey': 'owchannelManagement'
        // },
        // {
        //     'mainTitle': locale.logisticsMenu.accessStatistics,// 访问管理
        //     'id': 26,
        //     'icon': '',
        //     'pid': 18,
        //     'link': '/logisticsProvider.html#/accessStatistics',
        //     'menuKey': 'accessStatistics'
        }
    ]
};


// WEBPACK FOOTER //
// ./src/api/menuOwLogisticProvider.js